import type { CityConfig } from "../city-template/types";

export const collegeParkConfig: CityConfig = {
  city: "College Park",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "college-park",
  route: "/cities/college-park",
  title: "Emergency Passport College Park, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in College Park, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for College Park, Hyattsville, Riverdale, and Greenbelt residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in College Park, MD",
  heroSubtitle: "College Park travelers — from the University of Maryland campus to the vibrant neighborhoods of Prince George's County — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving students, faculty, and families.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20University%20of%20Maryland%20College%20Park%20campus%20with%20red-brick%20buildings%2C%20green%20lawns%2C%20McKeldin%20Mall%2C%20and%20the%20iconic%20Testudo%20statue%2C%20warm%20afternoon%20sunlight%20casting%20long%20shadows%2C%20collegiate%20atmosphere%20with%20trees%20and%20modern%20academic%20buildings%2C%20professional%20photography%2C%20no%20visible%20text%20or%20people%2C%20warm%20red%20and%20green%20tones%20with%20golden%20light&width=1800&height=700&seq=college-park-hero-001&orientation=landscape",
  heroImageAlt: "Aerial view of University of Maryland College Park campus with red-brick buildings and green lawns",
  geoPosition: "38.9897;-76.9378",
  geoPlacename: "College Park, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 30–40 minutes from College Park via US-1 S",
  },
  nearbyCitiesZips: [
    { name: "College Park", zips: "20740, 20741, 20742, 20783" },
    { name: "Hyattsville", zips: "20781, 20782, 20783, 20784, 20785, 20787, 20788" },
    { name: "Riverdale", zips: "20737, 20738" },
    { name: "Greenbelt", zips: "20768, 20770, 20771" },
    { name: "Berwyn Heights", zips: "20740" },
    { name: "Adelphi", zips: "20783, 20787" },
    { name: "Langley Park", zips: "20783, 20787" },
    { name: "Mount Rainier", zips: "20712" },
    { name: "Brentwood", zips: "20722" },
    { name: "Bladensburg", zips: "20710" },
    { name: "Edmonston", zips: "20781" },
    { name: "Landover Hills", zips: "20784" },
    { name: "Cheverly", zips: "20781, 20785" },
    { name: "Takoma Park", zips: "20912, 20913" },
    { name: "Beltsville", zips: "20704, 20705" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for College Park and Prince George's County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-graduation-cap-line", title: "Study Abroad Specialists", desc: "UMD students, faculty, and staff with international travel deadlines" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Bowie, MD", route: "/cities/bowie" },
    { name: "Emergency passport help in Greenbelt, MD", route: "/cities/greenbelt" },
    { name: "Urgent passport services in Silver Spring, MD", route: "/cities/silver-spring" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves College Park, Maryland remotely via secure registered courier. We do not have a walk-in office in College Park — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Prince George's County travelers without the long drive to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving College Park, Hyattsville, Riverdale, Greenbelt, and greater Prince George's County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the College Park area and Prince George's County. From the University of Maryland campus and research corridors to the diverse neighborhoods of Hyattsville and Riverdale, from the NASA Goddard Space Flight Center to the professionals commuting to DC — we serve all of College Park's vibrant community.",
  nearbyCitiesIntro: "We serve College Park and nearby communities including Hyattsville, Riverdale, Greenbelt, Berwyn Heights, Adelphi, Langley Park, Mount Rainier, Brentwood, Bladensburg, Edmonston, Landover Hills, Cheverly, Takoma Park, and Beltsville. We also serve students and staff from the University of Maryland and NASA Goddard.",
  howItWorksIntro: "Most College Park travelers complete everything online and ship documents overnight. No need to drive 30–40 minutes to downtown DC or navigate US-1 traffic during rush hour.",
  mistakesIntro: "College Park is a dynamic university town with students, faculty, and families with diverse travel needs. Here are the most common passport mistakes we see from College Park travelers.",
  testimonialsIntro: "College Park travelers — from students studying abroad to faculty on research trips to families visiting relatives — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in College Park, MD? Here are the most common ones we hear from University of Maryland and Prince George's County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Prince George's County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.princegeorgescountymd.gov/294/Vital-Records" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Prince George's County Circuit Court. Required for name change passport corrections.", url: "https://www.princegeorgescountymd.gov/294/Vital-Records" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for study abroad and research travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 30–40 min to downtown DC", "Full day commitment — challenging for students and faculty"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For College Park travelers with immediate departure needs — as fast as 24 hours. Perfect for last-minute study abroad, research trips, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Student and academic travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for College Park adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to College Park address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for College Park residents and students — including UMD students and international researchers.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for College Park residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for College Park families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for College Park residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport College Park MD", description: "Urgent passport processing for College Park Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal College Park MD", description: "Fast passport renewal for College Park Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport College Park MD", description: "New passport application services for College Park Maryland residents applying for their first passport." },
    { name: "Child Passport College Park MD", description: "Minor passport services for College Park Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "College Park, MD",
      rating: 5,
      text: "UMD study abroad program to Japan in 8 days and my passport was expired. Fast Passport Center reviewed everything, caught a photo issue, and had my passport ready in 3 days. I made my flight to Tokyo without any stress.",
      service: "Passport Renewal",
    },
    {
      name: "Prof. David Chen",
      location: "University of Maryland",
      rating: 5,
      text: "Research conference in Zurich with 6 days notice. Fast Passport Center delivered my renewed passport in 48 hours. Their service is essential for academics with unpredictable travel schedules.",
      service: "Emergency Passport",
    },
    {
      name: "The Williams Family",
      location: "Hyattsville, MD",
      rating: 5,
      text: "Family trip to Mexico with 2 weeks notice. Fast Passport Center handled all four passports including our two kids. The agent was incredibly patient explaining the parental consent requirements.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jake R.",
      location: "Riverdale, MD",
      rating: 5,
      text: "Lost my passport the week before my internship in London. I was panicked. Fast Passport Center walked me through the replacement process and had it in my hands in 48 hours. Saved my internship.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "college-park-1",
      name: "College Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4300 Knox Rd",
      city: "College Park",
      state: "MD",
      zip: "20740",
      phone: "(301) 699-3431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central College Park, near UMD campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary College Park acceptance facility. Convenient for UMD students and staff. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "college-park-2",
      name: "Hyattsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4325 Gallatin St",
      city: "Hyattsville",
      state: "MD",
      zip: "20781",
      phone: "(301) 779-5320",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hyattsville, approximately 3 miles southwest of College Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hyattsville, Mount Rainier, and Brentwood residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "college-park-3",
      name: "Greenbelt Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7600 Ora Glen Dr",
      city: "Greenbelt",
      state: "MD",
      zip: "20770",
      phone: "(301) 474-3823",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Greenbelt, approximately 4 miles east of College Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Greenbelt and NASA Goddard area. Good alternative for eastern Prince George's County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "college-park-4",
      name: "Prince George's County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "14735 Main St",
      city: "Upper Marlboro",
      state: "MD",
      zip: "20772",
      phone: "(301) 952-3318",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Upper Marlboro, approximately 12 miles southeast of College Park",
      website: "https://www.princegeorgescountymd.gov/",
      websiteLabel: "Prince George's County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via MD-214.",
      icon: "ri-government-line",
    },
    {
      id: "college-park-5",
      name: "Beltsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10901 Baltimore Ave",
      city: "Beltsville",
      state: "MD",
      zip: "20705",
      phone: "(301) 937-4357",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Beltsville, approximately 5 miles north of College Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving northern Prince George's County. Good alternative for Beltsville and northern College Park residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30–40 min drive to downtown DC", fpc: "No — ship from College Park" },
    { feature: "Student Travel Support", agency: "No flexibility for academic needs", fpc: "Yes — we handle study abroad cases" },
    { feature: "UMD Research & Faculty Travel", agency: "No academic travel expertise", fpc: "Yes — UMD faculty and research travel specialists" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "NASA Goddard Travel", agency: "No federal contractor support", fpc: "Yes — NASA Goddard and federal travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "College Park students and faculty often discover passport needs just weeks before study abroad or research travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Campus photo services and local shops in College Park sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Prince George's County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "College Park Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "College Park residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your dorm, apartment, or office in College Park or Hyattsville." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Route 1 or the UMD campus." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your College Park address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in College Park, MD?", a: "Fast Passport Center offers emergency passport processing in College Park, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (30–40 minutes from College Park) — without you needing to make the drive or navigate US-1 traffic." },
    { q: "Does College Park have its own passport agency?", a: "No — neither College Park nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 30–40 minutes from College Park via US-1. Fast Passport Center's courier service means College Park residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Hyattsville or Riverdale?", a: "Absolutely. Fast Passport Center serves all of the Prince George's County area including Hyattsville, Riverdale, Greenbelt, Berwyn Heights, Adelphi, Langley Park, Mount Rainier, Brentwood, Bladensburg, and Beltsville. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in College Park, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do College Park travelers use for international flights?", a: "Most College Park residents fly internationally through Baltimore-Washington International Airport (BWI), approximately 25–30 minutes east via I-95. Reagan National (DCA) is approximately 30–35 minutes south via US-1. Dulles (IAD) offers additional international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in College Park?", a: "Yes. Fast Passport Center handles multi-passport cases for families in College Park, Hyattsville, Riverdale, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to College Park?", a: "The College Park Post Office at 4300 Knox Rd is the primary acceptance facility, located near the UMD campus. The Hyattsville Post Office at 4325 Gallatin St serves southwestern Prince George's County. The Greenbelt Post Office at 7600 Ora Glen Dr serves eastern areas. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. College Park residents should plan ahead, especially for study abroad programs and summer family vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — College Park", address: "7411 Baltimore Ave, College Park, MD 20740", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Hyattsville", address: "6500 America Blvd, Hyattsville, MD 20782", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Greenbelt", address: "6000 Greenbelt Rd, Greenbelt, MD 20770", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Beltsville", address: "10401 Baltimore Ave, Beltsville, MD 20705", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — College Park", address: "6505 Belcrest Rd, Hyattsville, MD 20782", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Closest MVA to College Park and UMD campus. Full service including REAL ID processing. Appointments recommended.", featured: true },
    { name: "MVA — Largo", address: "10251 Central Ave, Largo, MD 20774", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full service MVA for Prince George's County. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "25–30 minutes from College Park via I-95",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for College Park travelers. Southwest Airlines hub with extensive domestic and international connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "30–35 minutes from College Park via US-1",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Convenient for business travel and domestic connections. Major hub for American Airlines.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "45–55 minutes from College Park via I-495",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};